export type Nullish = null | undefined;

/**
 * Check if a value is {@link Nullish}
 */
export function isNullish(value: unknown): value is Nullish {
    return typeof value === 'undefined' || value === null;
}
